<style>
.error-wrapper {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    min-height: 100vh;
    text-align: center;
}
.error-wrapper .error-heading {
    margin-top: 115px;
}
.error-wrapper .error-heading .headline {
    font-size: 285px;
    font-weight: 700;
    letter-spacing: 1px;
    margin-top: -130px;
}
.font-danger {
    color: #dc3545 !important;
}
.btn {
    padding: 0.375rem 1.75rem;
}
.btn-danger-gradien {
    background-image: -webkit-gradient(linear, left top, right top, from(#e25865), color-stop(51%, #c62232), to(#e25865));
    background-image: linear-gradient(to right, #e25865 0%, #c62232 51%, #e25865 100%);
    border: none;
    color: #fff;
    background-size: auto 200%;
    -webkit-transition: all 0.3s ease;
    transition: all 0.3s ease;
}
.error-wrapper .sub-content {
    font-size: 18px;
    color: #2b2b2b;
    letter-spacing: 1px;
    font-weight: normal;
    line-height: 35px;
    z-index: 3;
    position: relative;
    margin-top: 20px;
    margin-bottom: 0;
}
.error-wrapper .btn {
    margin-top: 20px;
}

.btn-lg {
    font-size: 18px;
}
@media only screen and (max-width: 575.98px) {
    .error-wrapper .error-heading .headline {
        font-size: 150px;
    }
    .error-wrapper .img-100 {
        width: 50px !important;
    }
    .error-wrapper {
        padding: 20px 0;
    }
}
</style>
<div class="error-wrapper">
<div class="container">
    <span class="text-center">
        <img class="img-100" src="https://cdn.estore5s.com/asset/emoji/sad.png" style="display:inline-block;" alt="">
    </span>
    <div class="error-heading">
      <h2 class="headline font-danger">403</h2>
    </div>
    <div class="col-md-8 offset-md-2">
      <p class="sub-content">We are Sorry... <br/> The page you are attempting to reach has restricted access.</p>
    </div>    
    <!-- <div><a class="btn btn-danger-gradien btn-lg" [href]='partnerPlatformURL + "/#/login?returnUrl=" + requestedPath'>Proceed to Login</a></div> -->
</div>
</div>